// import { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.rtl.min.css'
import './assets/css/style.css'
import './assets/css/all.min.css'

import {Login} from "./Pages/Account/Login";
import { Routes, Route } from "react-router-dom";
import Main from './Pages/Main';
import Signup from './Pages/Account/Signup';
import { PrivateOutlet } from './utils/PrivateOutlet';
import EditTheme from './Pages/Theme/EditTheme';
import Blog from './Pages/Blog/Blog';
import Error404 from './Layouts/Error404';
import Contact from './Pages/Contact';
import Message from './Pages/Message';
import Domain from './Pages/Domain';
import Package from './Pages/Package';
import EditPages from './Pages/Theme/EditPages';
import BlogEdit from './Pages/Blog/BlogEdit';
import BlogCreate from './Pages/Blog/BlogCreate';
import Invoice from './Pages/Invoice/Invoice';
import InvoiceView from './Pages/Invoice/InvoiceView';
import { Crisp } from "crisp-sdk-web";
import { useEffect } from 'react';
import Shop from './Pages/Shop/Shop';
import Client from './Pages/Shop/Client';
import Factor from './Pages/Shop/Factor';
import Product from './Pages/Product/Product';
import ProductEdit from './Pages/Product/ProductEdit';
import ProductCreate from './Pages/Product/ProductCreate';
import ProductCategory from './Pages/Product/ProductCategory';
import Tournament from './Pages/Modules/Ebro/Tournament/Tournament';
import Signups from './Pages/Modules/Ebro/Tournament/Signups';
import { ResetPass } from './Pages/Account/Reset';

function App() {
  useEffect(() => {
    Crisp.configure("fd6a172f-9d6a-4380-9658-5e549322dfcc");
  }, [])
  
  return(
    <Routes>
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="reset-pass" element={<ResetPass />} />
        <Route path="*" element={<PrivateOutlet />}>
            <Route index element={<Main />} />
            <Route path="edit-pages" element={<EditPages />}/> 
            <Route path="edit">
              <Route path=":pageId" element={<EditTheme />} />
              <Route path="*" element={<Error404 />} />
            </Route>
            <Route path="blog">
              <Route index element={<Blog />} />
              <Route path=":postId" element={<BlogEdit />} />
              <Route path="create" element={<BlogCreate />} />
              <Route path="*" element={<Error404 />} />
            </Route>
            <Route path="product">
              <Route index element={<Product />} />
              <Route path=":prodId" element={<ProductEdit />} />
              <Route path="create" element={<ProductCreate />} />
              <Route path="prod-category" element={<ProductCategory />} />
              <Route path="*" element={<Error404 />} />
            </Route>
            <Route path="invoice">
              <Route index element={<Invoice />} />
              <Route path=":invoiceId" element={<InvoiceView />} />
            </Route>
            <Route path="ebro-tours">
              <Route index element={<Tournament />} />
              <Route path="signups/:tourId/:tourName?" element={<Signups />} />
            </Route>
            <Route path="contact" element={<Contact />} />
            <Route path="shop" element={<Shop />} />
            <Route path="client" element={<Client />} />
            <Route path="factor" element={<Factor />} />
            <Route path="message" element={<Message />} />
            <Route path="domain" element={<Domain />} />
            <Route path="package" element={<Package />} />
            <Route path="*" element={<Error404 />} />
        </Route>
    </Routes>
  ) 
}

export default App;
